<template>
    <a v-if="url && asLink"
       :href="url"
       target="_blank"
       rel="noopener noreferrer"
       class="resident-portal-link"
       v-tooltip="$t('com.file.meeting.resident-portal-tooltip')">
        <img src="@/assets/icons/meetingsActions/building-columns.svg" class="resident-portal-link__icon resident-portal-link__icon--large" />
        <span class="resident-portal-link__text">{{ $t('com.file.meeting.resident-portal') }}</span>
    </a>
    <span v-else-if="url"
          class="resident-portal-link"
          v-tooltip="$t('com.file.meeting.resident-portal-tooltip')"
          @click.prevent.stop="open">
        <img src="@/assets/icons/meetingsActions/building-columns.svg" class="resident-portal-link__icon" />
        <span class="resident-portal-link__text">{{ $t('com.file.meeting.resident-portal') }}</span>
    </span>
</template>

<script>
    import { getResidentPortalSessionUrl } from "@/helpers/residentPortal.helper";

    export default {
        name: "ResidentPortalSessionLink",
        props: {
            isPublic: Boolean,
            code: String,
            asLink: Boolean,
        },
        computed: {
            // reaktywnie: me() wraca po zamontowaniu widokow, wiec nie wolno zrzucac wartosci do data()
            url() {
                return getResidentPortalSessionUrl(this.$store.state.userStore.residentPortal, this.isPublic, this.code);
            },
        },
        methods: {
            open() {
                if (this.url) {
                    window.open(this.url, "_blank", "noopener,noreferrer");
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .resident-portal-link {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        text-decoration: none;

        &__icon {
            width: 18px;
            height: 18px;

            &--large {
                width: 20px;
                height: 20px;
            }
        }

        &__text {
            font-weight: 500;
            font-size: 14px;
            color: #00082c;
        }

        &:hover .resident-portal-link__text {
            text-decoration: underline;
        }
    }
</style>
